import { FC, SetStateAction, Dispatch, useRef, useState, useEffect } from 'react';
import { AddAPhotoOutlined, DeleteOutline } from '@mui/icons-material';
import { useToastStore } from '../../stores';
import { HighlightCard } from '../highlight-card';
import { ImageContainer, ImageOverlay, UploadImagesButton } from './ImageUpload.styles';
import { Button } from '../button';

interface ImageUploadProps {
	imageOnServer?: string;
	imageToUpload: File | null;
	setImageToUpload: Dispatch<SetStateAction<File | null>>;
	altText?:string
}

const ImageUpload: FC<ImageUploadProps> = ({ imageOnServer, imageToUpload, setImageToUpload, altText }) => {
	const { setToast } = useToastStore();
	const fileInputRef = useRef<HTMLInputElement>(null);
	const [isEditing, setIsEditing] = useState(true);

	const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];

		if (file && file.size > 10_000_000) {
			setToast({
				message: 'A imagem excede o tamanho máximo de 10MB.',
				variant: 'error',
			});
			return;
		}

		if (file) {
			setImageToUpload(file);
			return;
		}

		setImageToUpload(null);
	};

	const handleRemoveFromFiles = () => {
		setImageToUpload(null);
		setIsEditing(true);
	};

	useEffect(() => {
		if (imageOnServer) {
			setIsEditing(false);
		}
	}, [imageOnServer]);

	return (
		<>
			<input
				id='uploadInput'
				type='file'
				ref={fileInputRef}
				accept='.png, .jpeg, .jpg'
				hidden
				onChange={handleFileSelect}
			/>
			{imageOnServer && !isEditing && (
				<HighlightCard variant='default'>
					<div style={{ position: 'relative' }}>
						<ImageContainer src={imageOnServer} alt={altText} />
						<ImageOverlay>
							<Button variant='contained' fitContent onClick={handleRemoveFromFiles}>
								<DeleteOutline fontSize='small' />
							</Button>
						</ImageOverlay>
					</div>
				</HighlightCard>
			)}
			{!!imageToUpload && isEditing && (
				<HighlightCard variant='default'>
					<div style={{ position: 'relative' }}>
						<ImageContainer src={URL.createObjectURL(imageToUpload)} alt={altText} />
						<ImageOverlay>
							<Button variant='contained' fitContent onClick={handleRemoveFromFiles}>
								<DeleteOutline fontSize='small' />
							</Button>
						</ImageOverlay>
					</div>
				</HighlightCard>
			)}
			{!imageToUpload && isEditing && (
				<HighlightCard variant='default'>
					<UploadImagesButton onClick={() => fileInputRef.current?.click()}>
						<AddAPhotoOutlined fontSize='inherit' />
					</UploadImagesButton>
				</HighlightCard>
			)}
		</>
	);
};

export default ImageUpload;
